import { trackWishlistActions, utagViewArtificialPageView } from 'features/tealium';
import unveil from 'ui/lazy-load/unveil';
import { redirectToCart, addToCart } from 'features/cart';
import { showAddToCartFailureModal } from 'features/cart/desktop';
import { trackAddToCartDy } from 'features/tealium/dynamicYield';
import { dataCaptureTimeout } from 'ui/config';
import decodeHtml from 'utilities/decodeHtml';

import dynamicImport from '../../../../../features/webpack/dynamicImport.macro';
import deleteWishList from '../deleteWishList';
import showOpenWishListModal from '../showOpenWishListModal';

const trackArtificialPageView = utagViewArtificialPageView();

function showShareWishlistModal () {

	dynamicImport('desktop/wishlist-email', '../../../../../features/wishList/desktop/email/initWishlistEmail.js').then(
		(module) => {

			const initWishlistEmail = module.default;
			initWishlistEmail();

		}
	);

	trackWishlistActions({ eventAction: 'Click-Share-List' });

}

function showPrintWishlistModal (hospitalityUrl) {

	if (hospitalityUrl) {

		$('body').lpModal({
			onInit: true,
			appendContentToForm: false,
			width: 500,
			height: 180,
			src: hospitalityUrl,
			lpModalClass: 'lpModalPrint lpModal--alt1'
		});

	} else {

		dynamicImport(
			'desktop/wishlist-print',
			'../../../../../features/wishList/desktop/print/initWishlistPrintModal.js'
		).then((module) => {

			const initWishlistPrintModal = module.default;
			initWishlistPrintModal();

		});

	}

	trackWishlistActions({ eventAction: 'Click-Print-List' });

}

function showDeleteWishlistModal () {

	trackWishlistActions({ eventAction: 'Click-Delete-List' });

	$('.wishlistItemPrice').show();

	window.lp.utils.hideStatusIndicator();
	// init unveil lazy loading
	unveil('img.unveil[data-src]');
	const wishlistHeaderName = document.querySelector('#wishlistHeaderName').textContent;

	$('body').lpModal({
		onInit: true,
		appendContentToForm: false,
		width: 400,
		height: 140,
		content: $(),
		lpModalClass: 'lpModalDelete lpModal--alt1',
		openEvt: () => {

			trackArtificialPageView({ pageName: 'Delete Wish List' });

		},
		closeEvt: () => {

			trackArtificialPageView({ pageName: '' });

		}
	});

	$.get('/wish-list/DeleteWishlistConfirm/', (response) => {

		$('#lpModalContent').html(response);

		document.querySelector('.wishListName').innerHTML = wishlistHeaderName;

		const $deleteWishlistModal = $('.lpModalDelete');
		$deleteWishlistModal.on('click', '.calloutBtn', (e) => {

			const $target = $(e.target);
			if ($target.hasClass('btnDelete')) {

				$target.prop('disabled', true);

				deleteWishList(
					null,
					() => {

						$('#lpModalClose').trigger('click');
						window.location.reload();

					},
					(error) => {

						$target.prop('disabled', false);
						$('.error', $deleteWishlistModal).text(error);

					}
				);

				trackWishlistActions({
					eventAction: 'Submit-Delete-List'
				});

			} else {

				// Cancel
				$('#lpModalClose').trigger('click');

			}

		});

	});

}

function showNewWishListModal () {

	dynamicImport('desktop/wishlist-create', '../../../../../features/wishList/desktop/create/initNewWishlist.js').then(
		(module) => {

			const initNewWishlist = module.default;
			initNewWishlist();

		}
	);

	trackWishlistActions({ eventAction: 'Click-Create-List' });

}

const WishListOpenView = Marionette.ItemView.extend({
	template: false,
	ui: {
		addAllItemsToCart: '.addAllItemsToCart',
		sharedWishlistLink: '#sharedWishlistLink',
		printWishlistLink: '#printWishlistLink',
		printHospitalityWishlistLink: '#printHospitalityWishlistLink',
		deleteWishListLink: '#deleteWishListLink',
		createWishListLink: '#createWishListLink',
		openWishListLink: '#openWishListLink'
	},
	events: {
		'click @ui.addAllItemsToCart': 'addAllToCartClick',
		'click  @ui.sharedWishlistLink': 'sharedWishlistLink',
		'click  @ui.printWishlistLink': 'printWishlistLink',
		'click  @ui.printHospitalityWishlistLink': 'printHospitalityWishlistLink',
		'click  @ui.deleteWishListLink': 'deleteWishListLink',
		'click  @ui.createWishListLink': 'createWishListLink',
		'click  @ui.openWishListLink': 'openWishListLink'
	},

	addAllToCartClick (e) {

		const allWishlistView = document.querySelectorAll('.wishlistView .wishlistResultContainer');

		const productItems = [];

		allWishlistView.forEach((item) => {

			const el = item.querySelector('.lnkAddToCart');
			const elInput = item.querySelector('.wishlistQtyInput ');
			const whistlistItems = {
				ShortSku: el.getAttribute('data-sku').toString(),
				Quantity: elInput.value,
				Name: decodeHtml(el.getAttribute('data-name')),
				Brand: el.getAttribute('data-brand'),
				Category: el.getAttribute('data-category'),
				Price: el.getAttribute('data-price'),
				SkuInputType: el.getAttribute('data-sku-input-type')
			};

			whistlistItems.customizedProductToken = el.getAttribute('data-customized-product-token');

			if (el.getAttribute('data-json-pattern')) {

				const info = JSON.parse(el.getAttribute('data-json-pattern'));
				const pcc = {
					LayerColor1: info.Color1,
					LayerColor2: info.Color2,
					LayerColor3: info.Color3,
					LayerColor4: info.Color4,
					LayerColor5: info.Color5,
					PatternId: info.PatternId,
					Trim: info.Trim
				};
				whistlistItems.PatternColorCombination = pcc;

			}

			if (window.top.DY) {

				try {

					trackAddToCartDy(whistlistItems.ShortSku, parseFloat((whistlistItems.Quantity * whistlistItems.Price).toFixed(2)), whistlistItems.Quantity);

				} catch (e) {

					console.warn('DY API is not available', e);

				}

			}

			return productItems.push(whistlistItems);

		});

		e.preventDefault();

		const successCallback = () => {

			trackWishlistActions({
				eventAction: 'Click-Add-All-To-Cart'
			});

			if (!window.lp.globals.enableDataCapture) {

				redirectToCart();
				return;

			}

			const { reporter } = window.lp.dataCapture;

			const atcRequest = reporter.trackAddToCart(productItems, document.querySelector('.addAllItemsToCart'));

			const timeout = window.setTimeout(redirectToCart, dataCaptureTimeout);
			Promise.all([ atcRequest ]).finally(() => {

				window.clearTimeout(timeout);
				redirectToCart();

			});

		};
		const request = addToCart({
			arrData: productItems,
			successCallback,
			errorCallback (errors, xhr, response) {

				showAddToCartFailureModal({
					cartStatus: errors,
					response,
					fromModal: false
				});

			},
			inlcudeCartOverview: false,
			rememberLastAddedItem: false
		});

	},

	sharedWishlistLink (e) {

		e.preventDefault();

		showShareWishlistModal();

	},

	printWishlistLink (e) {

		e.preventDefault();

		showPrintWishlistModal();

	},

	printHospitalityWishlistLink (e) {

		e.preventDefault();
		const { printUrl } = e.currentTarget.dataset;

		if (!printUrl) {

			return;

		}

		showPrintWishlistModal(printUrl);

	},

	deleteWishListLink (e) {

		e.preventDefault();

		showDeleteWishlistModal();

	},
	createWishListLink (e) {

		e.preventDefault();

		showNewWishListModal();

	},
	openWishListLink (e) {

		e.preventDefault();

		showOpenWishListModal();

	}
});

export default WishListOpenView;
